import { useState, useEffect } from "react";
import { useToastPromise } from "../../components/toastPromise";
import { SocialMediaController } from "../../controllers/socialMediaController";
import "../../assets/css/socialMedia.css";
import { SocialMedia } from "./socialMedia";
import { TableList } from "../../components/tableList";

export const AllSocialMedia = ({ user }) => {
  const toastPromise = useToastPromise();
  const [loading, setLoading] = useState(false);
  const [socialMediaList, setSocialMediaList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  useEffect(() => {
    getAll();
  }, []);
  const getAll = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        SocialMediaController.getAll({
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => {
        const fetchedData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setSocialMediaList(fetchedData);
        return "Social media details retrieved successfully.";
      },
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handleDeleteSelected = (selectedRows, success) => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        SocialMediaController.deleteAll({
          idList: selectedRows,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: success,
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handlePopupDialogOpen = (socialMedia = null) => {
    setSelectedData(socialMedia);
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <section id="socialMediaList">
      <h4>SOCIAL MEDIA LISTS</h4>
      <hr />
      <TableList
        loading={loading}
        list={socialMediaList}
        handlePopupDialogOpen={handlePopupDialogOpen}
        deletePromise={(selectedRows, success) => {
          handleDeleteSelected(selectedRows, success);
        }}
      />
      <SocialMedia
        user={user}
        isOpen={isOpen}
        handleClose={handleClose}
        getAll={getAll}
        selectedData={selectedData}
      />
    </section>
  );
};
